/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { Redirect } from 'react-router-dom';

import { AppHeaderScrollableText } from '../components/appNav/AppHeaderScrollable';
import ContentFrame from '../applicationFrame/ContentFrame';

import RouteNames from '../appAuthorized/RouteNames';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../components/ScrollAware';

import { ContentList } from '../contentViews/ContentList';
import { ProfileFileListItemFlaggedRight } from '../components/FileListItem';
import ContentWrapper from '../components/ContentWrapper';
import AppNavPhrases from '../../phraseKeys/AppNav.phrase';
import { filesZeroState } from '../components/healthEntriesList/ZeroState';
import { useActiveProfile } from '../hooks/useProfile';
import { useUIState } from '../hooks/useUIState';
import { useNavigate } from '../hooks/useNavigate';
import { useAvailableAttachments } from '../hooks/useAttachments';
import { attachmentTypes } from '../../models/AttachmentModel';
import AppUtils from '../../utilities/AppUtils';
import { useHealthEntryValuesForActiveProfile } from '../hooks/useHealthEntry';
import { useTrackableListForActiveProfile } from '../hooks/useTrackable';


function getFinalRoute(heValueToHeLookup, obsToTrackableLookup, attachmentType, parentId) {
  switch (attachmentType) {
    case attachmentTypes.healthEntryValue:
      return RouteNames.healthEntryValue(heValueToHeLookup[parentId], parentId);
    case attachmentTypes.healthEntry:
      return RouteNames.healthEntry(parentId);
    case attachmentTypes.trackable:
      return RouteNames.trackableObservationList(parentId);
    case attachmentTypes.trackableObservation:
      return RouteNames.trackableObservation(obsToTrackableLookup[parentId], parentId);
    default:
      return RouteNames.home();
  }
}
interface Props {
  location: any;
}
const MyBackpackSelection: React.FC<Props> = (props) => {
  const queryParams = AppUtils.getQueryParams(props.location.search);
  const { attachmentType } = queryParams;
  const parentId = Number(queryParams.parentId);
  const isValid = attachmentType && parentId;

  const [{ availableFileList }, availableAttachmentActions] = useAvailableAttachments(attachmentType, parentId);
  const [{ heValueToHeLookup }] = useHealthEntryValuesForActiveProfile();
  const [{ observationToTrackableId }] = useTrackableListForActiveProfile();
  const [{ isActiveProfileMainProfile }] = useUIState();
  const [{ greetingName }] = useActiveProfile();
  const [, navActions] = useNavigate();

  const titleValues = AppNavPhrases.backpackSelection.title(isActiveProfileMainProfile, greetingName);
  const files = availableFileList.map(f => ({ file: f }));
  const finalRoute = getFinalRoute(heValueToHeLookup, observationToTrackableId, attachmentType, parentId);

  if (!isValid) {
    return <Redirect to={RouteNames.myBackpack()} />;
  } else {
    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            cancel={() => {
              navActions.goBackTo(finalRoute);
            }}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText id={titleValues.id} values={titleValues.values} />

              <ContentWrapper>
                <ContentList
                  collection={files}
                  zeroState={filesZeroState}
                  onClickItem={(item) => {
                    availableAttachmentActions.onSelectFile(item.file, attachmentType, parentId)
                      .then(() => {
                        navActions.replace(finalRoute);
                      });
                  }}
                  itemComponent={ProfileFileListItemFlaggedRight}
                />
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
};

export default MyBackpackSelection;
